export const formatTimestamp = (date) => {
  if (!date)
    return new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

  let dateObj;
  if (date instanceof Date) { dateObj = date }
  else if (typeof date === "string" || typeof date === "number") { dateObj = new Date(date) }
  else { dateObj = new Date() }
  if (isNaN(dateObj.getTime())) { dateObj = new Date() }
  return dateObj.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};